import "./styles.css";
import React from "react";
import { TextField } from "@mui/material";

export default function KilometersItem() {
  return (
    <div className="kilometers-container" id="kilometers-container">
      <p className="kilometers-label" id="kilometers-title">
        KM
      </p>
      <TextField
        type="number"
        InputLabelProps={{
          shrink: true,
        }}
        className="kilometers"
        id="kilometers-text-field"
      />
    </div>
  );
}
